import { Link } from "react-router-dom";
import { useSEO } from "../lib/seo";
import { ShieldCheck, Heart, Sparkles, Users, ArrowRight } from "lucide-react";

export default function About() {
  useSEO({
    title: "About BeforeExam",
    description: "BeforeExam is a premium certification prep platform built by certified engineers. Real-exam practice tests, adaptive analytics, and a streak-powered prep engine.",
  });

  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden border-b border-border crest-bg text-white">
        <div className="aurora opacity-70" />
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="container-x relative py-20 max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-[color:var(--brand-gold)]">About us</div>
          <h1 className="mt-3 font-display text-4xl sm:text-6xl tracking-tighter leading-[1.05]">
            We help engineers <span className="font-serif text-gradient-gold">pass certifications</span> — and grow their careers.
          </h1>
          <p className="mt-5 text-lg text-white/80 max-w-2xl">
            BeforeExam is built by certified cloud engineers who got tired of free question dumps and out-of-date courses. Every question is hand-crafted, every explanation reviewed.
          </p>
        </div>
      </section>

      <section className="container-x py-16 grid md:grid-cols-3 gap-6">
        {[
          { i: <Heart className="h-6 w-6 text-[color:var(--brand-amber)]" />, t: "Made by engineers", d: "Every question is written by a certified engineer who's worked in production — not a content farm." },
          { i: <ShieldCheck className="h-6 w-6 text-[color:var(--brand-success)]" />, t: "Money-back, always", d: "If you don't pass after using BeforeExam diligently, we refund 100% within 30 days. No questions asked." },
          { i: <Sparkles className="h-6 w-6 text-[color:var(--brand-gold-deep)]" />, t: "Updated every month", d: "We refresh every course every 30 days against the latest exam objectives. Free updates for life." },
        ].map((b) => (
          <div key={b.t} className="rounded-xl border border-border bg-card p-6 card-hover">
            {b.i}
            <h3 className="mt-4 font-display text-lg">{b.t}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{b.d}</p>
          </div>
        ))}
      </section>

      <section className="container-x py-16 border-t border-border">
        <div className="grid md:grid-cols-3 gap-8 items-end">
          <div className="md:col-span-2">
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-[color:var(--brand-amber)]">Our promise</div>
            <h2 className="mt-2 font-display text-3xl sm:text-4xl tracking-tight">Practice today. Pass <span className="font-serif text-gradient-gold">tomorrow.</span></h2>
            <p className="mt-3 text-muted-foreground max-w-xl">
              We're a small, focused team based across India and Europe. Send us feedback any time — every email is read by a human.
            </p>
          </div>
          <Link to="/contact"><button className="btn-primary">Get in touch <ArrowRight className="h-4 w-4" /></button></Link>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-4 max-w-2xl">
          {[{ k: "184k+", v: "Students" }, { k: "94%", v: "Pass rate" }, { k: "4.8★", v: "Rating" }].map((s) => (
            <div key={s.v} className="rounded-xl border border-border p-5 bg-card">
              <div className="font-display text-3xl">{s.k}</div>
              <div className="text-xs text-muted-foreground mt-1">{s.v}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
